<div class="h-screen w-full mosaic-dark">
  <!-- Global Toast for Error Messages -->
  <p-toast position="top-right" [life]="5000" />

  <router-outlet />
</div>
